export const SHOPIFY_STORE_URL = process.env.REACT_APP_SHOPIFY_STORE_URL || 'shop.guildhalllearning.com';
export const SHOPIFY_ACCESS_TOKEN = process.env.REACT_APP_SHOPIFY_ACCESS_TOKEN || '0777ca4707ecff0cb4f0802d56ff722e';

export const getProductUrl = (handle) => `https://${SHOPIFY_STORE_URL}/products/${handle}`;
